import React, { useState, useEffect } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { getInloInfo, exportRowsToExcel } from "../common/commonMethod";
import { FxWindow } from "./../../fxms/windows/FxWindows";
import { columns5_5 } from "../ui/helper/UI_5_5.helper";
import {
  DataGrid,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { Box, Button } from "@mui/material";
import { UI_5_5_CU } from "./UI_5_5_CU";
import axios from "axios";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

/*관리자 > 감시대상관리*/
export const UI_5_5 = (props) => {
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo), user);

  const [rows, setRows] = React.useState([]);
  const [columns, setColumns] = useState(columns5_5);
  const [pageSize, setPageSize] = useState(25);
  const [selectedRow, setSelectedRow] = useState(null);
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };
  const [isModalAddOpen, setIsModalAddOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    submitBtnClick();
  }, [inlo, user]);

  const submitBtnClick = async () => {
    try {
      const uri = "vup/select_5_5";
      //   const param = {
      //     startDate: selectedFilter.startDate.replace(/-/gi, ""),
      //     endDate: selectedFilter.endDate.replace(/-/gi, ""),
      //     complexInloNo: selectedFilter.complexInloNo,
      //     companyInloNo: selectedFilter.companyInloNo,
      //     plantInloNo: selectedFilter.plantInloNo,
      //   };
      const param = {};
      const res = await FxmsData.selectGridData(uri, param);

      let index = 0;
      for (let data of res.data) {
        data.id = index++;
      }
      FxWindow.alert(res.data.length + " 건의 데이터가 조회되었습니다.");

      let response = res.data;
      response.map((item, index) => {
        return { ...item, id: index };
      });

      // 그리드에 데이터
      setRows(response);
      //  제외할 키 목록
      const excludedKeys = new Set([
        "id",
        "monTargetNo",
        "monTargetNm",
        "chkClNm",
        "regUserNo",
        "chgDtm",
        "chkClCd",
        "usePingChkYn",
        "useLatencyChkYn",
        "useCpuChkYn",
        "useHttpChkYn",
        "useDiskChkYn",
        "useMemoryChkYn",
        "useDataCntChkYn",
        "useYn",
        "ipAddrVal",
        "urlVal",
        "chgUserNo",
        "chkIntervalMin",
        "regDtm",
        "password",
        "port",
        "userId",
      ]);

      let result = response.flatMap((obj) => {
        // 필터링된 키들을 담을 배열
        const filteredKeys = [];

        // 기존 객체의 모든 키를 순회합니다.
        for (let key in obj) {
          // 제외할 키가 아니라면 배열에 추가합니다.
          if (!excludedKeys.has(key)) {
            filteredKeys.push({
              field: key,
              headerName: key,
              width: 120,
              headerClassName: "DataGridHeader",
              valueFormatter: (params) => {
                return new Intl.NumberFormat("ko-KR").format(params.value);
              },
            });
          }
        }

        //키 정렬
        filteredKeys.sort((a, b) => (a.field > b.field ? 1 : -1));
        return filteredKeys;
      });
      // 중복 제거
      result = Array.from(
        new Map(result.map((item) => [item.field, item])).values()
      );
      setColumns((prev) => [...columns5_5, ...result]);
    } catch (e) {
      console.log("UI_5_5 fetchData error", e);
    }
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer sx={{ float: "right" }} />
    );
  };

  const exportToExcel = () => {
    exportRowsToExcel({
      columns,
      rows,
      fileName: props.menuFullName || "tableData",
      sheetName: (props.menuFullName || "downloadData").replaceAll("/", "_"),
      excludeId: true
    });
  };

  const handleCreate = () => {
    setIsEdit(false);
    setIsModalAddOpen(true);
  };

  const handleUpdate = () => {
    setIsEdit(true);
    setIsModalAddOpen(true);
  };

  const handleOnClickRow = (params) => {
    setSelectedRow(params.row);
  };

  const handleDelete = async () => {
    FxWindow.confirm(
      `'${selectedRow.monTargetNm}' 감시를 중단하시겠습니까?`,
      async (result) => {
        if (result) {
          try {
            const response = await axios
              .delete(`/api/vup/delete_5_5/${selectedRow.monTargetNo}`, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + localStorage.getItem("token"),
                },
              })
              .then((result) => {
                console.log("UI_5_5 delete 성공", result);
                submitBtnClick();
              });
          } catch (e) {
            console.log("UI_5_5 delete fetchData error", e);
          }
        }
      }
    );
  };

  return (
    <div className="predict">
      <div className="FxCrudDataGrid">
        <div class="FxDataTitle">감시 대상</div>
        <div className="excelDown">
          <Button onClick={exportToExcel} startIcon={<FileDownloadIcon />}>
            엑셀 다운로드
          </Button>
        </div>
        <Box className="DataGridList" sx={{ height: "430px", width: "100%" }}>
          <DataGrid
            className="DataGrid"
            cellClassName="DataGridCell"
            rowHeight={36}
            rows={rows}
            columns={columns}
            components={{ Toolbar: CustomToolbar }}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
            rowsPerPageOptions={[25, 50, 100]}
            onRowClick={handleOnClickRow}
          ></DataGrid>
        </Box>

        <div style={{ height: "20%", width: "100%" }} class="FxCrudToolbar">
          <div class="FxFilterLeft">
            <input
              class="FxButtonToolbar"
              type="button"
              id="btnUpdate"
              value="수정"
              disabled={selectedRow ? false : true}
              onClick={handleUpdate}
            />
            <input
              class="FxButtonToolbar"
              type="button"
              id="btnDelete"
              value="삭제"
              disabled={selectedRow ? false : true}
              onClick={handleDelete}
            />
          </div>
          <div class="FxFilterRight">
            <input
              class="FxButtonToolbar"
              type="button"
              id="btnAdd2"
              value="추가"
              onClick={handleCreate}
            />
          </div>
          <UI_5_5_CU
            open={isModalAddOpen}
            closeModal={() => {
              setIsModalAddOpen(false);
              submitBtnClick();
            }}
            isEdit={isEdit}
            initialData={isEdit ? selectedRow : {}}
          />
        </div>
      </div>
    </div>
  );
};
